import(/* webpackMode: "eager" */ "/builds/jetspeak/jetclass-web/govoriru/app/(auth)/auth/page.tsx");
